import React from 'react';

import TagManager from 'react-gtm-module';

interface TagPayload {
  [key: string]: string | number | boolean | null;
}

interface TagManagerProps {
  event: string;
  payload: TagPayload;
  condition: boolean | string | number | undefined | null;
}

export const useTagManager = ({ event, payload, condition }: TagManagerProps) => {
  React.useEffect(() => {
    if (condition) {
      TagManager.dataLayer({
        dataLayer: {
          event,
          ...payload,
        },
      });
    }
  }, [condition, event, payload]);
};
